import { Component, Input, Pipe, PipeTransform, SecurityContext} from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements PipeTransform{
  
  constructor(
    public sanitizersupper: DomSanitizer,) {
  }
  colors: any = {
    converted: 'gray',
    archived: 'gray',
    raw: 'gray',
    classified: '#00B19e',
    edited: '#0094bc',
    'true': 'green',
    'false': 'gray',
    Golden: '#FFD700',
    Silver: '#C0C0C0',
    Bronze: '#CD7F32'
  };
  dataSource: any[] = [];
  selectedRows: any[] = [];
  showedRows: any[] = [];

  sortCounter: number = 0;
  sortValues: {[x:string]: any } = {};
  filterValues : {[x:string]: any } = {};

  totalRows = 0;
  navIndex = 0;
  totalNavigations = 0;

  

  transform (value: string): SafeHtml {
    return this.sanitizersupper.bypassSecurityTrustHtml(value);
  }
  setUpdatedContent(contents: any[], origin:string) {
    const formatter = origin === 'virtualcampus'? this.formatRowDisplayVca.bind(this) : this.formatRowDisplayVcl.bind(this);
    const contentMap = new Map(contents.map((element:any)=>[element.id_content, element]));
    this.dataSource = this.dataSource.map((row:any)=>{
      const element = contentMap.get(row.id_content);
      return element ? formatter(row, element) : row;
    });

    this.showedRows = this.showedRows.map((row:any)=>{
      const element = contentMap.get(row.id_content);
      return element ? formatter(row, element) : row;
    });
  }
  formatRowDisplayVcl(element: any, content: any) {
    if ('belongs' in content) element.belongs = content.belongs;
    if ('id_country' in content) element.id_country = content.id_country;
    if ('id_cycle' in content) element.id_cycle = content.id_cycle;
    if ('id_region' in content) element.id_region = content.id_region;
    if ('id_vcl_institution' in content) element.id_vcl_institution = content.id_vcl_institution;
    if ('id_study' in content) element.id_study = content.id_study;
    if ('study' in content) element.study = content.study;
    if ('id_class' in content) element.id_class = content.id_class;
    if ('class' in content) element.class = content.class;
    if ('id_module' in content) element.id_module = content.id_module;
    if ('module' in content) element.module = content.module;
    if ('id_year' in content) element.id_year = content.id_year;
    if ('year' in content) element.year = content.year;
    if ('id_period' in content) element.id_period = content.id_period;
    if ('period' in content) element.period = content.period;
    if ('id_section' in content) element.id_section = content.id_section;
    if ('section' in content) element.section = content.section;
    if ('id_type' in content) element.id_type = content.id_type;
    if ('type' in content) element.type = content.type;
    if ('id_content_learning' in content) element.id_content_learning = content.id_content_learning;
    if ('id_content_subject' in content) element.id_content_subject = content.id_content_subject;
    if ('id_content_replace' in content) element.id_content_replace = content.id_content_replace;

    if ('id_section' in content) element.year_name = [4, 5, 7].includes(content.id_section) ? `${content.id_content_learning ?? ''} ${content.content_name ?? ''}` : (content.year ?? '');
    if ('id_section' in content) element.type_chapter = content.id_section == 4 ? (content.chapter ?? '') : `${content.id_content_subject ?? ''} ${content.type ?? ''}`;

    if ('content_name' in content) element.content_name = content.content_name;
    if ('content_url' in content) element.content_url = content.content_url;
    if ('duplicate' in content) element.duplicate = content.duplicate;
    if ('state' in content) element.state = content.state;
    if ('active' in content) element.active = content.active;
    if ('state' in content) element.state_format = this.buildTagsHtml(content.state);
    if ('active' in content) element.active_format = this.buildTagsHtml(content.active.toString());
    if ('status' in content) element.status      =   content.status;
    return element;
  }
  formatRowDisplayVca(element:any, content:any){
    if ('department' in content) element.department = content.department;
    if ('semester' in content) element.semester = content.semester;
    if ('id_module' in content) element.id_module = content.id_module;
    if ('module' in content) element.module = content.module;
    if ('id_year' in content) element.id_year = content.id_year;
    if ('year' in content) element.year = content.year;
    if ('id_section' in content) element.id_section = content.id_section;
    if ('section' in content) element.section = content.section;
    if ('id_type' in content) element.id_type = content.id_type;
    if ('type' in content) element.type = content.type;
    if ('id_content_learning' in content) element.id_content_learning = content.id_content_learning;
    if ('id_content_subject' in content) element.id_content_subject = content.id_content_subject;
    if ('id_content_replace' in content) element.id_content_replace = content.id_content_replace;
    if ('id_section' in content) element.year_name   =   [4, 5, 7].includes(content.id_section)  ? ((content['id_content_learning'] ?? '')  + ' ' + (content['content_name'] ?? '')) : (content['year'] ?? '');
    if ('id_section' in content) element.type_chapter =   content.id_section == 4  ? (content['chapter'] ?? '')  : ((content['id_content_subject'] ?? '') + ' ' + (content['type'] ?? ''));
    if ('content_name' in content) element.content_name =   content.content_name;
    if ('content_url' in content) element.content_url =   content.content_url;
    if ('duplicate' in content) element.duplicate   =   content.duplicate;
    if ('state' in content) element.state       =   content.state;
    if ('active' in content) element.active      =   content.active;
    if ('state' in content) element.state_format = this.buildTagsHtml(content.state);
    if ('active' in content) element.active_format = this.buildTagsHtml(content.active.toString());
    if ('status' in content) element.status      =   content.status;
    return element;
  }
  
  selectAll(element: any) {
    if (element.checked) {
      this.showedRows.map((element:any) => {
        element['checked'] = true;
        return element;
        });
    } else {
      this.showedRows.map((element:any) => {
        element['checked'] = false;
        return element;
        });
    }
    
  }
  
  selectRow(element: any, indexShow:number) {
    if (element.checked) {
      this.showedRows[indexShow]['checked'] = true;
    } else {
      this.showedRows[indexShow]['checked'] = false;
    }
  }
  selectRows(){
    return this.showedRows.filter((element:any) => {
      if (element.checked) return element;
      });

  }
  
  applyFilter(value:string, column:string){
    this.filterValues[column] = value;
    Object.keys(this.filterValues).forEach(element => {if(this.filterValues[element] === "") delete this.filterValues[element] });
    
    this.applyFilterSort();
  }
  applyFilterOr(filterValues:any[]){
    let showedRows = JSON.parse(JSON.stringify(this.dataSource));
    
    if(filterValues.length > 0){
      showedRows = showedRows.filter((row:any) => {
        let findRow = false;
        filterValues.forEach((element:any)=>{
          let text = row[element.column]? this.normalizeString(row[element.column]):'';
  
          findRow = findRow || text.includes(this.normalizeString(element.value));
        });
        return findRow;
      });
      this.showedRows = showedRows;
    }else this.showedRows = this.dataSource;
  }

  applySort(element:any, column:string, type:string){
    let sortedValue = element.getAttribute('sorted')
    sortedValue = sortedValue==''?'asc':(sortedValue=='asc'?'desc':'')
    let rotateAngle = sortedValue==''?180:(sortedValue=='asc'?-180:0)
    element.setAttribute("sorted", sortedValue);
    if(sortedValue != '') element.style.color = "black"; else element.style.color = "darkgrey";
    element.style.transform="rotateX("+rotateAngle+"deg)";

    let pos = sortedValue == 'asc'? this.sortCounter++ :(sortedValue=='desc'?this.sortValues[column]['pos'] : 0)

    this.sortValues[column] = {pos: pos, sort: sortedValue, type: type};
    Object.keys(this.sortValues).forEach(element => {if(this.sortValues[element].sort == "") delete this.sortValues[element] });

    this.applyFilterSort();

  }
  applyFilterSort(){
    let showedRows = this.dataSource;//JSON.parse(JSON.stringify(this.dataSource));

    //Filter Data
    let filterValues = Object.entries(this.filterValues);
    if(filterValues.length > 0){
      showedRows = showedRows.filter((row:any) => {
        let findRow = true;
        filterValues.forEach(element=>{
          let column = element[0];
          let value = this.normalizeString(element[1]);
          let text = this.normalizeString(row[column] ?? '');
          let columnFind = column != 'all_column'? text.includes(value): this.normalizeString(Object.values(row).join(' ')).includes(value);
          
          findRow = findRow && columnFind;
        })
        return findRow;
      });
    }

    //Sort Data 
    let sortValues = Object.entries(this.sortValues)
    if(sortValues.length > 0){
      sortValues.sort((a, b) => { return a[1].pos - b[1].pos; });

      showedRows.sort((a:any, b:any) => {
        let compare = 0;
        sortValues.forEach(element=>{
            let column = element[0];
            let sort = element[1].sort;
            let type = element[1].type;
            let columnCompare;
            let valueA =  a[column]? a[column]:'';
            let valueB =  b[column]? b[column]:'';
            if(type == 'number') columnCompare = sort == 'asc'? valueA - valueB : valueB - valueA;
            if(type == 'string'|| type == 'date') columnCompare = sort == 'asc'? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            compare = compare || columnCompare;
          })

          return compare
      });
    }
    if(sortValues.length > 0 || filterValues.length > 0)
    this.showedRows = showedRows;
    else this.showedRows = this.dataSource;
    
  }
  normalizeString(str:string){
    return str.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }
  removeDetailsRows(tableBody:any){
    Array.from(tableBody.children).forEach((element:any)=>{
      if(element.getAttribute('detail')) element.remove()
    });
  }
  buildTagsHtml(value: string){
    if (!value) return '';
    let htmlValue =  value.replace('splited,', '').split(',').map(tag => tag.trim()).filter(tag => tag).map(tag =>
        `<span class="btn-primary btn-sm"
          style="margin:1px; padding:3px; border-radius:4px; color:white; background-color:${this.colors[tag] || 'gray'}">${tag}</span>`
      ).join('');
      return this.sanitizersupper.bypassSecurityTrustHtml(htmlValue);
  }
}
